<template>
  <div class="page-content">
    <el-row type="flex" align="middle" :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="6">
        <el-button class="egl-btn-yellow" style="width: 200px;" @click="openDialog('create')">
          {{ $locale("memberAgeGroup.create") }}
        </el-button>
      </el-col>
      <el-col :span="18">
        <p class="note">{{ $locale("memberAgeGroup.note") }}</p>
      </el-col>
    </el-row>

    <el-table :data="list" class="egl-table">
      <el-table-column :label="$locale('memberAgeGroup.name')" prop="name" />
      <el-table-column :label="$locale('memberAgeGroup.ageRange')">
        <template slot-scope="scope">{{ ageRangeLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column :label="$locale('memberAgeGroup.sort')" prop="sort" />
      <el-table-column :label="$locale('global.control')" min-width="180" align="center">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="openDialog('edit', scope.row)">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :visible.sync="isDialogOpen"
      :show-close="true"
      class="egl-dialog-elm"
      :title="actionType === 'create' ? $locale('memberAgeGroup.create') : $locale('memberAgeGroup.edit')"
      :close-on-click-modal="false"
    >
      <el-form :model="formObj" :rules="formRules" ref="detailForm" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('memberAgeGroup.name')" prop="name">
              <el-input v-model="formObj.name" :placeholder="$locale('membership.detail.form.plsEnter')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$locale('memberAgeGroup.sort')">
              <el-input-number v-model="formObj.sort" :min="0" :step="1" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('memberAgeGroup.minAge')" prop="minAge">
              <el-input-number v-model="formObj.minAge" :min="0" :max="150" :step="1" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$locale('memberAgeGroup.maxAge')">
              <el-input-number v-model="formObj.maxAge" :min="0" :max="150" :step="1" />
              <!-- 输入框太窄，placeholder 显示不全，所以改成输入框下方的小字提示 -->
              <p class="input-hint">{{ $locale('memberAgeGroup.maxAge.hint') }}</p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" style="margin-top: 40px;">
          <el-col :span="12" style="display: flex; justify-content: space-around;">
            <el-button class="egl-btn-white" style="width: 180px;" @click="isDialogOpen = false">
              {{ $locale("global.cancel") }}
            </el-button>
            <el-button class="egl-btn-yellow" style="width: 180px;" @click="save_fn">
              {{ $locale("global.confirm2") }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMemberAgeGroupListService,
  createMemberAgeGroupService,
  updateMemberAgeGroupService,
  deleteMemberAgeGroupService
} from "@/helpers/service/api/membership"
import countDownAlert from "@/utils/countDownAlert";
export default {
  created() {
    this.getList()
  },
  data() {
    return {
      list: [],
      isDialogOpen: false,
      actionType: "create",
      formObj: this.emptyForm(),
      formRules: {
        name: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourName"),
            trigger: "blur",
          }
        ]
      }
    }
  },
  methods: {
    emptyForm() {
      return { id: null, name: "", minAge: 0, maxAge: undefined, sort: 0 }
    },
    ageRangeLabel(row) {
      const min = row.minAge == null ? "" : row.minAge
      return row.maxAge == null ? `${min}歳以上` : `${min}〜${row.maxAge}歳`
    },
    getList() {
      getMemberAgeGroupListService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
        this.list = (res.data && res.data.list) || []
      })
    },
    openDialog(type, row) {
      this.actionType = type
      this.isDialogOpen = true
      this.$nextTick(() => {
        this.formObj = type === "edit"
          ? { id: row.id, name: row.name, minAge: row.minAge, maxAge: row.maxAge == null ? undefined : row.maxAge, sort: row.sort }
          : this.emptyForm()
      })
    },
    save_fn() {
      this.$refs.detailForm.validate(valid => {
        if (!valid) { return false }
        const params = {
          brandId: window.localStorage.getItem("brandId"),
          name: this.formObj.name,
          minAge: this.formObj.minAge,
          // 留空 = 没有上限
          maxAge: this.formObj.maxAge === undefined || this.formObj.maxAge === "" ? null : this.formObj.maxAge,
          sort: this.formObj.sort
        }
        const request = this.actionType === "create"
          ? createMemberAgeGroupService(params)
          : updateMemberAgeGroupService({ ...params, id: this.formObj.id })
        request.then(res => {
          if (res.success) {
            countDownAlert({
              content: this.actionType === "create"
                ? this.$locale("global.createSuccessfully")
                : this.$locale("global.updateSuccessfully"),
              callback: () => {
                this.isDialogOpen = false
                this.getList()
              }
            })
          }
        })
      })
    },
    delete_fn(row) {
      this.$confirm(`${this.$locale("global.delete")} ${row.name}?`, "", { type: "warning" }).then(() => {
        // 被会员制度或自动规则引用时，服务端会拒绝删除并返回引用方的名称
        deleteMemberAgeGroupService(row.id).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully"), callback: () => this.getList() })
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.note,
.input-hint {
  margin: 0;
  font-size: 12px;
  color: #999;
}
.input-hint {
  line-height: 20px;
  margin-top: 4px;
}
</style>
